// useBreadcrumbText.ts
import { useLocation } from "react-router-dom";

interface BreadCrumbInfo {
    text: string;
    href: string;
}

function splitPathName(pathname : string): BreadCrumbInfo[] {
    if (pathname === '/') {
        return [{ text: 'Home', href: '/' }];
    }

    const parts = pathname.split('/').filter(part => part);
    return parts.map((part, index) => ({
    text: part.charAt(0).toUpperCase() + part.slice(1),
    href: '/' + parts.slice(0, index + 1).join('/')
    }));

}

export default function useBreadcrumbText() {
  const { pathname } = useLocation();  
  
  const breadcrumbParts = splitPathName(pathname);

  return breadcrumbParts ; 
}
